/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BulkTracksRequestDto interface.
 */
export function instanceOfBulkTracksRequestDto(value) {
    if (!('ids' in value) || value['ids'] === undefined)
        return false;
    return true;
}
export function BulkTracksRequestDtoFromJSON(json) {
    return BulkTracksRequestDtoFromJSONTyped(json, false);
}
export function BulkTracksRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ids': json['ids'],
    };
}
export function BulkTracksRequestDtoToJSON(json) {
    return BulkTracksRequestDtoToJSONTyped(json, false);
}
export function BulkTracksRequestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ids': value['ids'],
    };
}
